



























































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import FormPrefillService from "@/services/FormPrefillService";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketSkdAdopsi from "@/store/modules/SuketSkdAdopsi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SkdAdopsiTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // MCU adopsi dapat diterbitkan di poli MCU/Penyakit Dalam mana pun → izinkan
  // di seluruh unit; kunci read-only tetap dari edit-window halaman (48 jam).
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.SkdAdopsi);
  suketStore = StoreSuketSkdAdopsi;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  konteks: any = {
    mode_pemohon: "pasangan-menikah",
    lama_pernikahan: null,
    pasangan_nama: null,
    pasangan_nik: null,
    pasangan_agama: null
  };
  anamnesis: any = {
    keluhan_utama: null,
    rpd: null,
    penyakit_kronis: null,
    penyakit_menular: null,
    riwayat_jiwa: null,
    napza: null,
    alergi: null,
    riwayat_sosial_rokok: null,
    riwayat_sosial_alkohol: null
  };
  fisik: any = {
    kesadaran: "Compos mentis",
    td_sistolik: null,
    td_diastolik: null,
    nadi: null,
    napas: null,
    suhu: null,
    spo2: null,
    bb: null,
    tb: null,
    imt: null,
    lingkar_perut: null,
    status_generalis: null,
    status_mental: null
  };
  lab: any = {
    hematologi: null,
    gula_puasa: null,
    gula_2jpp: null,
    lipid: null,
    ureum: null,
    kreatinin: null,
    egfr: null,
    sgot: null,
    sgpt: null,
    urinalisis: null,
    hiv: { hasil: null, interpretasi: null },
    hbsag: { hasil: null, interpretasi: null },
    hcv: { hasil: null, interpretasi: null },
    vdrl: { hasil: null, interpretasi: null },
    napza: { hasil: null, interpretasi: null }
  };
  radiologi: any = { thorax: null, ekg: null };
  rujukan_kj: any = { nomor: null, ringkasan: null };
  consent: any = {
    mcu: false,
    vct_hiv: false,
    disclosure: false,
    pihak_penerima: null
  };
  edukasi: any = null;
  kesimpulan: any = null;
  kesimpulan_catatan: any = null;
  diagnosis_tambahan: any = null;

  openPanels = [2, 3, 4, 7];
  saving = false;
  tarikLoading = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  modePemohonOptions = [
    { text: "Pasangan Menikah", value: "pasangan-menikah" },
    { text: "Tunggal (kasus khusus)", value: "tunggal-special-case" }
  ];
  interpretasiOptions = [
    "Non-Reaktif",
    "Reaktif",
    "Negatif",
    "Positif",
    "Borderline"
  ];
  kesimpulanOptions = ["SEHAT", "SEHAT DENGAN CATATAN", "TIDAK SEHAT"];
  skriningFields = [
    { key: "hiv", label: "HIV (Anti-HIV)" },
    { key: "hbsag", label: "HBsAg" },
    { key: "hcv", label: "Anti-HCV" },
    { key: "vdrl", label: "VDRL / TPHA" },
    { key: "napza", label: "Tes NAPZA (Urin)" }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get umur() {
    return this.pasien.tgl_lahir
      ? getAge(formatDMYDate(this.pasien.tgl_lahir))
      : "-";
  }

  get ageWarning() {
    const age = Number(this.umur);
    return !isNaN(age) && (age < 30 || age > 55);
  }

  get imtKet() {
    const v = Number(this.fisik.imt);
    if (!v) return "";
    if (v >= 30) return "Obesitas";
    if (v >= 25) return "Overweight";
    if (v >= 18.5) return "Normal";
    return "Underweight";
  }

  get reactiveLabWarning() {
    return this.skriningFields.some(f => {
      const i = (this.lab[f.key].interpretasi || "").toLowerCase();
      return i === "reaktif" || i === "positif";
    });
  }

  get catatanRules() {
    if (this.kesimpulan && this.kesimpulan !== "SEHAT") {
      return [
        v => (!!v && v.length >= 50) || "Wajib diisi minimal 50 karakter"
      ];
    }
    return [];
  }

  get alamatOptions() {
    const opts = [
      { id: "ktp", name: this.pasien.alamat, category: "Alamat KTP" }
    ];
    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }
    return opts;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.SkdAdopsi, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        konteks: this.konteks,
        anamnesis: this.anamnesis,
        fisik: this.fisik,
        lab: this.lab,
        radiologi: this.radiologi,
        rujukan_kj: this.rujukan_kj,
        consent: this.consent,
        edukasi: this.edukasi,
        kesimpulan: this.kesimpulan,
        kesimpulan_catatan: this.kesimpulan_catatan,
        diagnosis_tambahan: this.diagnosis_tambahan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.surat_date = d?.surat_date || new Date();
    this.signee_user_id = d?.signee_user_id || this.user.id;
    this.creator_user_id = d?.creator_user_id || this.user.id;
    this.alamat_type = d?.content?.alamat_type || "ktp";

    const c = d?.content;
    if (c) {
      this.konteks = { ...this.konteks, ...(c.konteks || {}) };
      this.anamnesis = { ...this.anamnesis, ...(c.anamnesis || {}) };
      this.fisik = { ...this.fisik, ...(c.fisik || {}) };
      this.lab = {
        ...this.lab,
        ...(c.lab || {}),
        hiv: { ...this.lab.hiv, ...((c.lab && c.lab.hiv) || {}) },
        hbsag: { ...this.lab.hbsag, ...((c.lab && c.lab.hbsag) || {}) },
        hcv: { ...this.lab.hcv, ...((c.lab && c.lab.hcv) || {}) },
        vdrl: { ...this.lab.vdrl, ...((c.lab && c.lab.vdrl) || {}) },
        napza: { ...this.lab.napza, ...((c.lab && c.lab.napza) || {}) }
      };
      this.radiologi = { ...this.radiologi, ...(c.radiologi || {}) };
      this.rujukan_kj = { ...this.rujukan_kj, ...(c.rujukan_kj || {}) };
      this.consent = { ...this.consent, ...(c.consent || {}) };
      this.edukasi = c.edukasi || null;
      this.kesimpulan = c.kesimpulan || null;
      this.kesimpulan_catatan = c.kesimpulan_catatan || null;
      this.diagnosis_tambahan = c.diagnosis_tambahan || null;
    }
  }

  setImt() {
    const bb = Number(this.fisik.bb);
    const tb = Number(this.fisik.tb);
    if (bb > 0 && tb > 0) {
      this.fisik.imt = (bb / Math.pow(tb / 100, 2)).toFixed(2);
    } else {
      this.fisik.imt = null;
    }
  }

  @Watch("fisik.bb")
  watchBb() {
    this.setImt();
  }

  @Watch("fisik.tb")
  watchTb() {
    this.setImt();
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  @Watch("loadedRatio")
  changeLoadedRatio() {
    // noop — keep parity with sibling suket cards
  }

  save() {
    if (this.saving) return;

    // Honesty guard (mirror backend): kesimpulan wajib; bila ≠ SEHAT wajib
    // justifikasi ≥ 50 karakter.
    if (!this.kesimpulan) {
      appModule.sendErrorAlert("Kesimpulan medis wajib diisi");
      return;
    }
    if (
      this.kesimpulan !== "SEHAT" &&
      (this.kesimpulan_catatan || "").length < 50
    ) {
      appModule.sendErrorAlert(
        "Justifikasi klinis wajib diisi minimal 50 karakter bila kesimpulan bukan SEHAT"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        StoreSuketSkdAdopsi.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  readonly kesadaranLabel: Record<string, string> = {
    cm: "Compos Mentis",
    apatis: "Apatis",
    delirium: "Delirium",
    somnolen: "Somnolen",
    sopor: "Sopor",
    "semi-coma": "Semi Coma",
    coma: "Coma",
    ringan: "Ringan",
    sedang: "Sedang",
    berat: "Berat"
  };

  async tarikAsesmen() {
    if (this.tarikLoading) return;
    this.tarikLoading = true;
    try {
      const payload = await FormPrefillService.fetchPrefill(
        this.pasien_rm,
        "suket_skd_adopsi",
        {
          register_id: this.register_id,
          sources: ["anamnesis_terkini", "klinis_terkini"]
        }
      );
      const fields = (payload && payload.fields) || {};

      const anamnesisMap: Record<string, string> = {
        "anamnesis.keluhan_utama": "keluhan_utama",
        "anamnesis.rpd": "rpd",
        "anamnesis.alergi": "alergi",
        "anamnesis.riwayat_jiwa": "riwayat_jiwa"
      };
      const fisikMap: Record<string, string> = {
        "fisik.td_sistolik": "td_sistolik",
        "fisik.td_diastolik": "td_diastolik",
        "fisik.nadi": "nadi",
        "fisik.napas": "napas",
        "fisik.suhu": "suhu",
        "fisik.spo2": "spo2",
        "fisik.kesadaran": "kesadaran",
        "fisik.bb": "bb",
        "fisik.tb": "tb"
      };

      const anamnesis = { ...this.anamnesis };
      const fisik = { ...this.fisik };
      const terisi: string[] = [];

      Object.keys(anamnesisMap).forEach(path => {
        const v = fields[path];
        if (v === undefined || v === null || v === "") return;
        anamnesis[anamnesisMap[path]] = v;
        terisi.push(path);
      });

      Object.keys(fisikMap).forEach(path => {
        let v = fields[path];
        if (v === undefined || v === null || v === "") return;
        if (path === "fisik.kesadaran") {
          v = this.kesadaranLabel[String(v)] || v;
        }
        fisik[fisikMap[path]] = v;
        terisi.push(path);
      });

      this.anamnesis = anamnesis;
      this.fisik = fisik;

      if (terisi.length > 0) {
        if (!this.openPanels.includes(1)) this.openPanels.push(1);
        if (!this.openPanels.includes(2)) this.openPanels.push(2);
        appModule.NoticeDelay(
          terisi.length + " kolom terisi dari catatan kunjungan ini"
        );
        FormPrefillService.logAcceptance({
          form_key: "suket_skd_adopsi",
          pasien_rm: this.pasien_rm,
          register_id: this.register_id,
          unit_id: this.unit_id,
          event: "accepted",
          fields: terisi,
          provenance: (payload && payload.provenance) || {},
          sources: ["anamnesis_terkini", "klinis_terkini"]
        });
      } else {
        appModule.sendErrorAlert(
          "Belum ada anamnesis atau TTV yang tercatat pada kunjungan ini"
        );
      }
    } finally {
      this.tarikLoading = false;
    }
  }

  close() {
    this.expandInput = false;
  }
}
